import './setImmediate'
import {AppRegistry} from 'react-native';
import Entry from './Entry';
import {name as appName} from './app.json';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDWTGW1wdeuZao_LBuBUD-ReUqvgBcZp_E",
  authDomain: "willijofirebase.firebaseapp.com",
  databaseURL: "https://willijofirebase-default-rtdb.firebaseio.com",
  projectId: "willijofirebase",
  storageBucket: "willijofirebase.appspot.com",
  messagingSenderId: "649569469172",
  appId: "1:649569469172:web:ff4aa79ced82be8d6754a1",
  measurementId: "G-XHCLMPCXMD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAnalytics(app);

//AppRegistry.registerComponent(appName, () => Entry);

export default Entry;